import { render, staticRenderFns } from "./AdminSlider.vue?vue&type=template&id=b65b53e2&scoped=true&"
import script from "./AdminSlider.vue?vue&type=script&lang=js&"
export * from "./AdminSlider.vue?vue&type=script&lang=js&"
import style0 from "./AdminSlider.vue?vue&type=style&index=0&id=b65b53e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65b53e2",
  null
  
)

export default component.exports